import { render, staticRenderFns } from "./DevelopExample.pug?vue&type=template&id=aedbeab6&scoped=true&lang=pug&"
import script from "./DevelopExample.vue?vue&type=script&lang=js&"
export * from "./DevelopExample.vue?vue&type=script&lang=js&"
import style0 from "./DevelopExample.scss?vue&type=style&index=0&id=aedbeab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedbeab6",
  null
  
)

export default component.exports